<template>
  <b-container fluid class="px-0">
    <!-- nav bar -->

    <b-navbar class="top-bar w-100">
      <b-container class="p-0">
        <div class="navbar-content-wrapper top-bar-content p-0">
          <b-navbar-brand class="top-bar-title title-section">Explore skills</b-navbar-brand>
          <b-navbar-nav class="categories-section">
            <b-form-group class="p-0">
              <b-form-checkbox-group
                id="filter-type"
                v-model="selectedFilters"
                :options="filterOptions"
                name="checkbox-filter-options"
                class="filter-checkbox-group text-primary overlay-checkbox-group p-0"
                @change="applyFilters"
              >
              </b-form-checkbox-group>
            </b-form-group>
          </b-navbar-nav>

          <b-navbar-nav class="d-flex flex-row align-items-center more-filter-section">
            <div class="button--toggle-verify">
              <b-form-checkbox
                id="free-verification-switch"
                v-model="isFreeVerification"
                switch
                button-variant="success"
                class="free-verification-switch"
                @change="applyFilters"
              >
                <div class="switch-label text-primary">Verify for free</div>
              </b-form-checkbox>
            </div>

            <b-nav-item-dropdown
              id="more-filter-dropdown"
              text="more filter"
              variant="outline-primary"
              class="more-filter-dropdown"
              boundary="viewport"
              right
              no-caret
              toggle-class="d-flex align-items-center filter-button"
            >
              <template #button-content>
                <div class="button--more-filter">
                  <svg
                    width="16"
                    height="10"
                    viewBox="0 0 16 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="more-filter-icon"
                  >
                    <path
                      d="M6.33333 10H9.66667V8.33333H6.33333V10ZM0.5 0V1.66667H15.5V0H0.5ZM3 5.83333H13V4.16667H3V5.83333Z"
                      fill="#3C44B1"
                    />
                  </svg>
                  <span class="ml-2 text-primary more-filter-text">More filter</span>
                </div>
              </template>

              <b-dropdown-header>
                <span class="text-primary-dark dropdown-header-text">Type</span>
              </b-dropdown-header>
              <b-dropdown-form>
                <div class="custom-radio-container">
                  <div
                    v-for="option in moreFilterOptions"
                    :key="option.value"
                    class="custom-radio-item"
                  >
                    <b-form-radio
                      v-model="selectedCourseType"
                      :value="option.value"
                      class="position-relative custom-radio-button"
                      @change="applyMoreFilters"
                    >
                      {{ option.text }}
                      <div class="subtitle">{{ option.subTitle }}</div>
                    </b-form-radio>
                  </div>
                </div>
              </b-dropdown-form>

              <b-dropdown-header
                ><span class="text-primary-dark dropdown-header-text"
                  >Publish</span
                ></b-dropdown-header
              >
              <b-dropdown-item
                v-for="option in sortOptions"
                :key="option.value"
                :active="selectedSort === option.value"
                @click="selectSortOption(option.value)"
              >
                {{ option.text }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>
      </b-container>
    </b-navbar>

    <!-- list learning units -->
    <div v-if="isLoading" class="container min-vh-100">
      <base-loading-state />
    </div>

    <div class="list__lu-content">
      <div v-if="isLoading" class="text-center py-4">
        <b-spinner label="Loading..." variant="primary" />
      </div>

      <!-- Recommended Section -->
      <div v-else>
        <div
          v-if="reccommendsLu.length > 0"
          class="list__lu-reccommends container__recommended-mcs"
        >
          <!-- Using LearningUnitCardList for recommended items -->
          <learning-unit-card-list
            :items="reccommendsLu"
            :item-class="['learning-card']"
            @clickItem="onCardClick"
          >
            <template #header>
              <div class="card-title text-primary-dark">
                <div>Recommended skills for growth</div>
                <p>Key Abilities to Elevate Your Career and Personal Development</p>
              </div>
            </template>
          </learning-unit-card-list>

          <!-- Load more button for recommended items -->
          <div
            v-if="recommendedPagination.currentPage < recommendedPagination.totalPages"
            class="text-center my-4"
          >
            <b-button
              variant="outline-primary"
              :disabled="loadingRecommended"
              @click="loadMoreRecommended"
            >
              <span v-if="loadingNonRecommended">
                <b-spinner small></b-spinner>
              </span>

              <span v-else> View More </span>
            </b-button>
          </div>
        </div>

        <!-- Non-Recommended Section -->
        <div v-if="nonReccommendsLu.length > 0" class="list__lu-non-reccommends container__mcs">
          <!-- Using LearningUnitCardList for non-recommended items -->
          <learning-unit-card-list
            v-if="nonReccommendsLu.length > 0"
            :items="nonReccommendsLu"
            :item-class="['learning-card']"
            @clickItem="onCardClick"
          >
            <template #header>
              <div class="card-title">All key skills for success</div>
            </template>
          </learning-unit-card-list>

          <!-- Load more button for non-recommended items -->
          <div
            v-if="nonRecommendedPagination.currentPage < nonRecommendedPagination.totalPages"
            class="text-center my-4"
          >
            <b-button
              variant="outline-primary"
              :disabled="loadingNonRecommended"
              @click="loadMoreNonRecommended"
            >
              <span v-if="loadingNonRecommended">
                <b-spinner small></b-spinner>
              </span>

              <span v-else> View More </span>
            </b-button>
          </div>
        </div>
        <div
          v-else-if="reccommendsLu.length === 0 && nonReccommendsLu.length === 0"
          class="text-center py-4 min-vh-100"
        >
          <p class="text-muted">Sorry, we couldn't find any results</p>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import LearningUnitCardList from './components/LearningUnitCardList.vue';
import LearningUnit from '@/models/LearningUnit';
import BaseLoadingState from '@/components/base-components/BaseLoadingState';

export default {
  name: 'ExploreLearningUnit',
  components: {
    LearningUnitCardList,
    BaseLoadingState
  },
  data() {
    return {
      isLoading: true,
      reccommendsLu: [],
      nonReccommendsLu: [],
      loadingRecommended: false,
      loadingNonRecommended: false,
      filters: {},
      // Filter and sort selections
      selectedFilters: [],
      isFreeVerification: false,
      selectedCourseType: null,
      selectedSort: 'newest',
      // Filter and sort options
      filterOptions: [
        { text: 'Business', value: 'business' },

        { text: 'Education', value: 'education' },
        { text: 'Technology', value: 'technology' },
        { text: 'Science & Engineering', value: 'science-&-engineering' }
      ],
      moreFilterOptions: [
        { text: 'All', value: null },
        {
          text: 'Learn + Verify',
          subTitle: 'สำหรับการเรียนรู้บทเรียนออนไลน์ ก่อนส่งหลักฐาน พิสูจน์ความสามารถ',
          value: 'learn_verify'
        },
        {
          text: 'Verify',
          subTitle: 'สำหรับการส่งหลักฐานพิสูจน์ความสามารถเท่านั้น',
          value: 'verify'
        }
      ],
      sortOptions: [
        { text: 'Latest -  Oldest', value: 'publish-new-old' },
        { text: 'Oldest -  Latest', value: 'publish-old-new' }
      ],
      // Pagination for non-recommended items
      nonRecommendedPagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 6,
        totalPages: 0
      },
      // Pagination for recommended items
      recommendedPagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 3,
        totalPages: 0
      },
      nonRecommendedCurrentStart: 0,
      recommendedCurrentStart: 0
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      // Reset pagination and data before fetching
      this.nonRecommendedCurrentStart = 0;
      this.recommendedCurrentStart = 0;
      this.nonReccommendsLu = [];
      this.reccommendsLu = [];

      // Fetch both recommended and non-recommended items
      await this.fetchNonRecommended();
      await this.fetchRecommended();
      this.isLoading = false;
    },

    onCardClick(item) {
      // Handle card click event
      // This method is triggered when a user clicks on a card item
      this.$router.push({
        name: 'micro-credentials/detail',
        params: { learningUnitId: item.id }
      });
    },

    async fetchNonRecommended() {
      this.loadingNonRecommended = true;
      try {
        // Call the API with proper pagination parameters and filters
        const {
          response: { data }
        } = await LearningUnit.api().fetchNonRecommended({
          _start: this.nonRecommendedCurrentStart,
          _limit: this.nonRecommendedPagination.itemsPerPage,
          ...this.filters // Include any active filters
        });
        // If this is the first load or a refresh, replace the array
        // Otherwise append to existing items
        if (this.nonRecommendedCurrentStart === 0) {
          this.nonReccommendsLu = data.items;
        } else {
          this.nonReccommendsLu = [...this.nonReccommendsLu, ...data.items];
        }

        // Update pagination information
        this.nonRecommendedPagination = data.pagination;
      } catch (error) {
        console.error('Error fetching non-recommended data:', error);
      } finally {
        this.loadingNonRecommended = false;
      }
    },

    async fetchRecommended() {
      this.loadingRecommended = true;

      try {
        // Call the API with proper pagination parameters
        const {
          response: { data }
        } = await LearningUnit.api().fetchRecommended({
          _start: this.recommendedCurrentStart,
          _limit: this.recommendedPagination.itemsPerPage,

          ...this.filters // Include both types of media details
        });

        // If this is the first load or a refresh, replace the array
        // Otherwise append to existing items
        if (this.recommendedCurrentStart === 0) {
          this.reccommendsLu = data.items;
        } else {
          this.reccommendsLu = [...this.reccommendsLu, ...data.items];
        }

        // Update pagination information
        this.recommendedPagination = data.pagination;
      } catch (error) {
        console.error('Error fetching recommended data:', error);
      } finally {
        this.loadingRecommended = false;
      }
    },

    async loadMoreNonRecommended() {
      // Update the start parameter to fetch the next page of non-recommended items
      this.nonRecommendedCurrentStart += this.nonRecommendedPagination.itemsPerPage;
      await this.fetchNonRecommended();
    },

    async loadMoreRecommended() {
      // Update the start parameter to fetch the next page of recommended items
      this.recommendedCurrentStart += this.recommendedPagination.itemsPerPage;
      await this.fetchRecommended();
    },

    applyFilters() {
      // Reset pagination
      this.nonRecommendedCurrentStart = 0;
      this.recommendedCurrentStart = 0;

      // Apply the selected filters
      const filterParams = {};

      // Handle category filters

      // Pass selected categories as a categories_slug array
      filterParams.category_slugs = this.selectedFilters;

      // Handle free verification filter
      if (this.isFreeVerification) {
        filterParams.is_verify_for_free = true;
      }

      // Handle course type filter if it was previously selected

      this.filters = { ...this.filters, ...filterParams };
      if (!this.isFreeVerification) {
        delete this.filters.is_verify_for_free;
      }
      this.fetchData();
    },

    applyMoreFilters() {
      // Reset pagination
      this.nonRecommendedCurrentStart = 0;
      this.recommendedCurrentStart = 0;

      // Apply course type filters
      const filterParams = { ...this.filters };

      if (this.selectedCourseType) {
        filterParams.mode = this.selectedCourseType;
      } else {
        // If "All" is selected, remove the course_type filter
        delete filterParams.mode;
      }

      this.filters = filterParams;

      this.fetchData();
    },

    selectSortOption(value) {
      this.selectedSort = value;
      this.applySort();
    },

    applySort() {
      // Reset pagination
      this.nonRecommendedCurrentStart = 0;
      this.recommendedCurrentStart = 0;

      // Apply the selected sorting
      const sortParams = {};
      sortParams._sort = this.selectedSort;

      // Preserve existing filter selections and combine with new sort parameter
      const currentFilters = { ...this.filters };
      delete currentFilters._sort; // Remove any existing sort parameter

      this.filters = { ...currentFilters, ...sortParams };

      this.fetchData();
    }
  }
};
</script>

<style lang="scss" scoped>
.more-filter-icon {
  width: 16px;
  height: 10px;
}
.text-primary-dark {
  color: #3b3e66;
}
.dropdown-header-text {
  font-weight: 700;
  font-size: 15.2px;
}
.explore-v2 {
  min-height: 100vh;
  grid-auto-rows: min-content;
  display: grid;
}

/* Top Bar Styling */
.top-bar {
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  padding: 24px 0;
}

.top-bar-title {
  color: #3b3e66;
  font-size: 24px;
  font-weight: 600;
}

::v-deep .filter-checkbox-group {
  display: flex;
  width: 100%;
  font-size: 16px;
  justify-content: space-between;
}

.filter-checkbox-group .custom-control {
  margin-right: 0px;
}

::v-deep .filter-checkbox-group .custom-control-label {
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  word-break: break-word;
}
::v-deep .filter-checkbox-group .custom-control-label::before,
::v-deep .filter-checkbox-group .custom-control-label::after {
  left: -1.6rem;
  top: 0rem;
}

.filter-checkbox-group .custom-checkbox .custom-control-label::before {
  border-radius: 3px;
  border: 1px solid #adb5bd;
}

.filter-checkbox-group
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.switch-label {
  margin-left: 0px;
  font-size: 16px;
  font-weight: 700;
}
::v-deep .free-verification-switch .custom-control-label::before {
  background-color: #d1d2db;
  left: -3rem;
}
::v-deep .free-verification-switch .custom-control-label::after {
  background-color: white;
  left: -2.9rem;
}
.free-verification-switch {
  padding-left: 50px;
}
::v-deep
  .free-verification-switch
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #d1d2db;
}
::v-deep .free-verification-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #1bc943;
  border-color: #1bc943;
}
.subtitle {
  font-size: 16px;
  color: #6c757d;
  margin-top: 0.25rem;
  width: 356px;
}

/* More Filter Dropdown Styling */
.more-filter-dropdown {
  margin-bottom: 0;

  ::v-deep .dropdown-menu {
    border-radius: 0.5rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border: none;
  }
}
::v-deep .navbar-expand .navbar-nav .more-filter-dropdown .nav-link {
  padding: 0;
}

/* Style for dropdown form */
::v-deep .dropdown-form {
  padding: 0.5rem 1rem;
  min-width: 200px;
}

/* Style for the dropdown menu */
::v-deep .dropdown-menu {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: absolute !important;
  z-index: 1050;
}

/* Style for scrollable dropdown */
::v-deep .scrollable-dropdown {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}

::v-deep .scrollable-dropdown::-webkit-scrollbar {
  width: 6px;
}

::v-deep .scrollable-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

::v-deep .scrollable-dropdown::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 6px;
}

::v-deep .scrollable-dropdown::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Filter button styling */
.filter-button {
  font-weight: 500;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.filter-button:hover {
  background-color: #f8f9fa;
}

/* Position the dropdown */
.more-filter-dropdown {
  position: relative;
}

/* Page content styling */
.card {
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.card-title {
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 40px;

  p {
    font-weight: 400;
    font-size: 20px;
    margin: 0;
  }
}
.card-text {
  font-size: 20px;
}

.card-body {
  padding: 1.5rem;
}

.text-center {
  margin: 15px 0;
}

/* Add specific styling for the learning cards */
::v-deep .learning-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

::v-deep .learning-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Ensure the b-overlay covers the entire width */
::v-deep .b-overlay {
  width: 100%;
}

/* Add spacing between load more button and card list */
::v-deep .grid__cards {
  margin-bottom: 2rem;
}

.categories-section fieldset {
  width: 100%;
  margin: 0;
}
.button--more-filter {
  border: #d1d2db 1px solid;
  border-radius: 3.2px;
  padding: 8px 12px;
  height: 44px;
  width: fit-content;
  display: flex;
  align-items: center;
}
.button--toggle-verify {
  border: #d1d2db 1px solid;
  border-radius: 3.2px;
  padding: 8px 12px;
  margin-right: 8px;
  height: 44px;
  width: fit-content;
  display: flex;
  align-items: center;
}

.title-section {
  grid-area: title;
}
.categories-section {
  width: 100%;
  grid-area: filters;

  justify-items: space-between;
  justify-self: center;
  align-content: center;
}
.more-filter-section {
  grid-area: actions;
  justify-self: end;
}
.top-bar-content {
  width: 100%;
  display: grid;
  grid-template-columns: 160px minmax(560px, 4fr) minmax(337px, 1fr);
  grid-template-areas: 'title filters actions';
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.list__lu-content {
  display: grid;
  padding: 40px 32px;
}

.custom-container {
  max-width: calc(1140px + 32px);
  margin: auto;
}

@media (max-width: 1199px) {
  .top-bar {
    padding: 24px 32px;
  }

  .filter-checkbox-group {
    margin-top: 20px;
  }

  .top-bar-content {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto auto;
    grid-template-areas:
      'title actions'
      'filters filters';
  }
  .categories-section {
    max-width: fit-content;
  }
}

@media screen and (max-width: 991px) {
  .top-bar-content {
    grid-template-columns: 1fr 2fr;
    row-gap: 20px;
  }

  .top-bar {
    padding: 32px;
  }

  .filter-checkbox-group {
    margin-top: 0;
  }

  .list__lu-content {
    padding: 40px 32px;
  }
}

@media screen and (max-width: 767px) {
  .top-bar {
    padding: 16px;
  }
  ::v-deep .filter-checkbox-group .custom-control-label {
    font-size: 12px;
  }

  .card-title {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 20px;

    p {
      font-size: 16px;
    }
  }
  .card-text {
    font-size: 16px;
  }
  .switch-label {
    font-size: 12.8px;
  }
  .button--more-filter {
    height: 28px;
    width: 44px;
  }
  .button--toggle-verify {
    height: 28px;
    width: fit-content;
  }
  ::v-deep .free-verification-switch label {
    font-size: 12.8px;

    padding-top: 3px;
  }
  ::v-deep .free-verification-switch .custom-control-label::after {
    left: -2.9rem;
  }

  .top-bar-title {
    font-size: 18px;
    font-weight: 700;
  }

  .more-filter-text {
    display: none;
  }
  .categories-section {
    max-width: 100%;
  }
  .list__lu-content {
    padding: 20px 16px;
  }
}
@media screen and (max-width: 575px) {
  .top-bar {
    padding: 16px 16px 0 16px;
  }

  .list__lu {
    margin: 20px 16px;
  }
  .categories-section {
    max-width: 100%;
    padding: 0;
  }
  .top-bar-content {
    grid-template-rows: auto 60px;
    row-gap: 28px;
  }
  ::v-deep .filter-checkbox-group .custom-control-label::before,
  ::v-deep .filter-checkbox-group .custom-control-label::after {
    left: 30%;
    top: -1.4rem;
    width: 20.8px;
    height: 20.8px;
  }
  ::v-deep .filter-checkbox-group label {
    text-align: center;
    max-width: 65px;
  }
  ::v-deep .custom-control-inline {
    margin-right: 0px;
    padding: 0px;
  }
  .subtitle {
    width: 205px;
  }
}
</style>
